// Country → IANA timezone mapping. Used when an Agent/Lead has a country but
// no explicit timezone override. Editable from admin settings later if needed.
//
// For ambiguous countries (US, CA, RU, AU, BR) we pick a sensible default and
// flag them with `ambiguous: true` so the UI can offer a per-lead override.

export const COUNTRY_TIMEZONE_MAP = {
  // Europe
  NL: { tz: "Europe/Amsterdam", city: "Amsterdam", weekend: ["Sat", "Sun"] },
  ES: { tz: "Europe/Madrid", city: "Madrid", weekend: ["Sat", "Sun"] },
  GB: { tz: "Europe/London", city: "London", weekend: ["Sat", "Sun"] },
  UK: { tz: "Europe/London", city: "London", weekend: ["Sat", "Sun"] },
  DE: { tz: "Europe/Berlin", city: "Berlin", weekend: ["Sat", "Sun"] },
  FR: { tz: "Europe/Paris", city: "Paris", weekend: ["Sat", "Sun"] },
  IT: { tz: "Europe/Rome", city: "Rome", weekend: ["Sat", "Sun"] },
  PT: { tz: "Europe/Lisbon", city: "Lisbon", weekend: ["Sat", "Sun"] },
  TR: { tz: "Europe/Istanbul", city: "Istanbul", weekend: ["Sat", "Sun"] },
  BE: { tz: "Europe/Brussels", city: "Brussels", weekend: ["Sat", "Sun"] },
  CH: { tz: "Europe/Zurich", city: "Zurich", weekend: ["Sat", "Sun"] },
  AT: { tz: "Europe/Vienna", city: "Vienna", weekend: ["Sat", "Sun"] },
  PL: { tz: "Europe/Warsaw", city: "Warsaw", weekend: ["Sat", "Sun"] },
  CZ: { tz: "Europe/Prague", city: "Prague", weekend: ["Sat", "Sun"] },
  SE: { tz: "Europe/Stockholm", city: "Stockholm", weekend: ["Sat", "Sun"] },
  NO: { tz: "Europe/Oslo", city: "Oslo", weekend: ["Sat", "Sun"] },
  DK: { tz: "Europe/Copenhagen", city: "Copenhagen", weekend: ["Sat", "Sun"] },
  FI: { tz: "Europe/Helsinki", city: "Helsinki", weekend: ["Sat", "Sun"] },
  IE: { tz: "Europe/Dublin", city: "Dublin", weekend: ["Sat", "Sun"] },
  GR: { tz: "Europe/Athens", city: "Athens", weekend: ["Sat", "Sun"] },
  RO: { tz: "Europe/Bucharest", city: "Bucharest", weekend: ["Sat", "Sun"] },
  HU: { tz: "Europe/Budapest", city: "Budapest", weekend: ["Sat", "Sun"] },
  RU: { tz: "Europe/Moscow", city: "Moscow", weekend: ["Sat", "Sun"], ambiguous: true },
  UA: { tz: "Europe/Kyiv", city: "Kyiv", weekend: ["Sat", "Sun"] },

  // Middle East (Fri+Sat weekend)
  AE: { tz: "Asia/Dubai", city: "Dubai", weekend: ["Fri", "Sat"] },
  SA: { tz: "Asia/Riyadh", city: "Riyadh", weekend: ["Fri", "Sat"] },
  QA: { tz: "Asia/Qatar", city: "Doha", weekend: ["Fri", "Sat"] },
  KW: { tz: "Asia/Kuwait", city: "Kuwait", weekend: ["Fri", "Sat"] },

  // Asia
  CN: { tz: "Asia/Shanghai", city: "Shanghai", weekend: ["Sat", "Sun"] },
  HK: { tz: "Asia/Hong_Kong", city: "Hong Kong", weekend: ["Sat", "Sun"] },
  JP: { tz: "Asia/Tokyo", city: "Tokyo", weekend: ["Sat", "Sun"] },
  KR: { tz: "Asia/Seoul", city: "Seoul", weekend: ["Sat", "Sun"] },
  TW: { tz: "Asia/Taipei", city: "Taipei", weekend: ["Sat", "Sun"] },
  SG: { tz: "Asia/Singapore", city: "Singapore", weekend: ["Sat", "Sun"] },
  IN: { tz: "Asia/Kolkata", city: "Mumbai", weekend: ["Sat", "Sun"] },
  PH: { tz: "Asia/Manila", city: "Manila", weekend: ["Sat", "Sun"] },
  TH: { tz: "Asia/Bangkok", city: "Bangkok", weekend: ["Sat", "Sun"] },
  ID: { tz: "Asia/Jakarta", city: "Jakarta", weekend: ["Sat", "Sun"] },
  PK: { tz: "Asia/Karachi", city: "Karachi", weekend: ["Sat", "Sun"] },
  BD: { tz: "Asia/Dhaka", city: "Dhaka", weekend: ["Fri", "Sat"] },
  VN: { tz: "Asia/Ho_Chi_Minh", city: "Ho Chi Minh City", weekend: ["Sat", "Sun"] },
  MY: { tz: "Asia/Kuala_Lumpur", city: "Kuala Lumpur", weekend: ["Sat", "Sun"] },
  LK: { tz: "Asia/Colombo", city: "Colombo", weekend: ["Sat", "Sun"] },
  IL: { tz: "Asia/Jerusalem", city: "Tel Aviv", weekend: ["Fri", "Sat"] },
  IR: { tz: "Asia/Tehran", city: "Tehran", weekend: ["Fri", "Sat"] },
  IQ: { tz: "Asia/Baghdad", city: "Baghdad", weekend: ["Fri", "Sat"] },
  JO: { tz: "Asia/Amman", city: "Amman", weekend: ["Fri", "Sat"] },
  LB: { tz: "Asia/Beirut", city: "Beirut", weekend: ["Sat", "Sun"] },
  OM: { tz: "Asia/Muscat", city: "Muscat", weekend: ["Fri", "Sat"] },
  BH: { tz: "Asia/Bahrain", city: "Manama", weekend: ["Fri", "Sat"] },

  // Africa
  NG: { tz: "Africa/Lagos", city: "Lagos", weekend: ["Sat", "Sun"] },
  ZA: { tz: "Africa/Johannesburg", city: "Johannesburg", weekend: ["Sat", "Sun"] },
  EG: { tz: "Africa/Cairo", city: "Cairo", weekend: ["Fri", "Sat"] },
  MA: { tz: "Africa/Casablanca", city: "Casablanca", weekend: ["Sat", "Sun"] },
  KE: { tz: "Africa/Nairobi", city: "Nairobi", weekend: ["Sat", "Sun"] },
  GH: { tz: "Africa/Accra", city: "Accra", weekend: ["Sat", "Sun"] },
  TN: { tz: "Africa/Tunis", city: "Tunis", weekend: ["Sat", "Sun"] },
  DZ: { tz: "Africa/Algiers", city: "Algiers", weekend: ["Fri", "Sat"] },
  ET: { tz: "Africa/Addis_Ababa", city: "Addis Ababa", weekend: ["Sat", "Sun"] },

  // Americas (US/CA ambiguous → default east)
  US: { tz: "America/New_York", city: "New York", weekend: ["Sat", "Sun"], ambiguous: true },
  CA: { tz: "America/Toronto", city: "Toronto", weekend: ["Sat", "Sun"], ambiguous: true },
  MX: { tz: "America/Mexico_City", city: "Mexico City", weekend: ["Sat", "Sun"] },
  BR: { tz: "America/Sao_Paulo", city: "São Paulo", weekend: ["Sat", "Sun"], ambiguous: true },
  AR: { tz: "America/Buenos_Aires", city: "Buenos Aires", weekend: ["Sat", "Sun"] },
  CL: { tz: "America/Santiago", city: "Santiago", weekend: ["Sat", "Sun"] },
  CO: { tz: "America/Bogota", city: "Bogotá", weekend: ["Sat", "Sun"] },

  // Oceania
  AU: { tz: "Australia/Sydney", city: "Sydney", weekend: ["Sat", "Sun"], ambiguous: true },
  NZ: { tz: "Pacific/Auckland", city: "Auckland", weekend: ["Sat", "Sun"] },
};

// Spanish country names → ISO2 (matches what is already used in the GTX forms).
export const COUNTRY_NAME_TO_CODE = {
  "España": "ES", "Spain": "ES",
  "Países Bajos": "NL", "Netherlands": "NL", "Holanda": "NL",
  "Reino Unido": "GB", "United Kingdom": "GB", "UK": "GB",
  "Alemania": "DE", "Germany": "DE",
  "Francia": "FR", "France": "FR",
  "Italia": "IT", "Italy": "IT",
  "Portugal": "PT",
  "Turquía": "TR", "Turkey": "TR",
  "Emiratos Árabes Unidos": "AE", "UAE": "AE", "United Arab Emirates": "AE",
  "Arabia Saudita": "SA", "Saudi Arabia": "SA",
  "China": "CN",
  "Hong Kong": "HK",
  "Japón": "JP", "Japan": "JP",
  "Corea del Sur": "KR", "South Korea": "KR",
  "Taiwán": "TW", "Taiwan": "TW",
  "Singapur": "SG", "Singapore": "SG",
  "India": "IN",
  "Filipinas": "PH", "Philippines": "PH",
  "Tailandia": "TH", "Thailand": "TH",
  "Indonesia": "ID",
  "Nigeria": "NG",
  "Sudáfrica": "ZA", "South Africa": "ZA",
  "Egipto": "EG", "Egypt": "EG",
  "Marruecos": "MA", "Morocco": "MA",
  "Estados Unidos": "US", "United States": "US", "USA": "US",
  "Canadá": "CA", "Canada": "CA",
  "México": "MX", "Mexico": "MX",
  "Brasil": "BR", "Brazil": "BR",
  "Argentina": "AR",
  "Chile": "CL",
  "Colombia": "CO",
  "Australia": "AU",
  "Nueva Zelanda": "NZ", "New Zealand": "NZ",
  // Asia extras
  "Pakistán": "PK", "Pakistan": "PK",
  "Bangladés": "BD", "Bangladesh": "BD",
  "Vietnam": "VN",
  "Malasia": "MY", "Malaysia": "MY",
  "Sri Lanka": "LK",
  "Israel": "IL",
  "Irán": "IR", "Iran": "IR",
  "Irak": "IQ", "Iraq": "IQ",
  "Jordania": "JO", "Jordan": "JO",
  "Líbano": "LB", "Lebanon": "LB",
  "Omán": "OM", "Oman": "OM",
  "Baréin": "BH", "Bahrain": "BH",
  "Catar": "QA", "Qatar": "QA",
  "Kuwait": "KW",
  // Africa extras
  "Kenia": "KE", "Kenya": "KE",
  "Ghana": "GH",
  "Túnez": "TN", "Tunisia": "TN",
  "Argelia": "DZ", "Algeria": "DZ",
  "Etiopía": "ET", "Ethiopia": "ET",
  // Europe extras
  "Bélgica": "BE", "Belgium": "BE",
  "Suiza": "CH", "Switzerland": "CH",
  "Austria": "AT",
  "Polonia": "PL", "Poland": "PL",
  "Chequia": "CZ", "Czech Republic": "CZ", "Czechia": "CZ",
  "Suecia": "SE", "Sweden": "SE",
  "Noruega": "NO", "Norway": "NO",
  "Dinamarca": "DK", "Denmark": "DK",
  "Finlandia": "FI", "Finland": "FI",
  "Irlanda": "IE", "Ireland": "IE",
  "Grecia": "GR", "Greece": "GR",
  "Rumanía": "RO", "Romania": "RO",
  "Hungría": "HU", "Hungary": "HU",
  "Rusia": "RU", "Russia": "RU",
  "Ucrania": "UA", "Ukraine": "UA",
};

// Common cities → country mapping. Used as a fallback when a lead has city/city_area
// but no country (e.g. when a prospect list dumps everything into the City column).
export const CITY_TO_COUNTRY = {
  // UAE
  "dubai": "AE", "dafza": "AE", "deira": "AE", "bur dubai": "AE", "jafza": "AE",
  "naif": "AE", "abu dhabi": "AE", "ajman": "AE", "sharjah": "AE",
  "ras al khaimah": "AE", "rak": "AE", "umm al quwain": "AE", "fujairah": "AE",
  // Saudi
  "riyadh": "SA", "jeddah": "SA", "dammam": "SA", "mecca": "SA",
  // Other GCC
  "doha": "QA", "kuwait city": "KW", "manama": "BH",
  // EU capitals
  "madrid": "ES", "barcelona": "ES", "valencia": "ES", "sevilla": "ES",
  "amsterdam": "NL", "rotterdam": "NL", "the hague": "NL",
  "london": "GB", "manchester": "GB", "birmingham": "GB",
  "berlin": "DE", "munich": "DE", "hamburg": "DE", "frankfurt": "DE",
  "paris": "FR", "lyon": "FR", "marseille": "FR",
  "rome": "IT", "milan": "IT", "naples": "IT",
  "lisbon": "PT", "porto": "PT",
  "istanbul": "TR", "ankara": "TR",
  // Asia
  "shenzhen": "CN", "guangzhou": "CN", "shanghai": "CN", "beijing": "CN",
  "hong kong": "HK", "tokyo": "JP", "osaka": "JP",
  "seoul": "KR", "taipei": "TW", "singapore": "SG",
  "mumbai": "IN", "delhi": "IN", "bangalore": "IN", "chennai": "IN", "kolkata": "IN",
  "manila": "PH", "bangkok": "TH", "jakarta": "ID",
  // Africa / Americas
  "lagos": "NG", "abuja": "NG", "johannesburg": "ZA", "cape town": "ZA", "durban": "ZA",
  "cairo": "EG", "alexandria": "EG",
  "casablanca": "MA", "rabat": "MA",
  "nairobi": "KE", "mombasa": "KE", "accra": "GH", "tunis": "TN", "algiers": "DZ",
  "addis ababa": "ET", "addis abeba": "ET",
  "new york": "US", "los angeles": "US", "miami": "US", "chicago": "US",
  "houston": "US", "boston": "US", "san francisco": "US", "dallas": "US", "seattle": "US",
  "toronto": "CA", "vancouver": "CA", "montreal": "CA", "calgary": "CA", "ottawa": "CA",
  "mexico city": "MX", "guadalajara": "MX", "monterrey": "MX",
  "sao paulo": "BR", "são paulo": "BR", "rio de janeiro": "BR", "brasilia": "BR",
  "buenos aires": "AR", "cordoba": "AR",
  "santiago": "CL", "bogota": "CO", "bogotá": "CO", "medellin": "CO", "medellín": "CO",
  "lima": "PE",
  "sydney": "AU", "melbourne": "AU", "brisbane": "AU", "perth": "AU",
  "auckland": "NZ", "wellington": "NZ",
  // Asia extras
  "karachi": "PK", "lahore": "PK", "islamabad": "PK", "rawalpindi": "PK",
  "dhaka": "BD", "chittagong": "BD",
  "ho chi minh city": "VN", "hanoi": "VN", "saigon": "VN",
  "kuala lumpur": "MY", "penang": "MY",
  "colombo": "LK",
  "tel aviv": "IL", "jerusalem": "IL", "haifa": "IL",
  "tehran": "IR", "isfahan": "IR",
  "baghdad": "IQ", "basra": "IQ",
  "amman": "JO", "beirut": "LB", "muscat": "OM",
  // Europe extras
  "brussels": "BE", "antwerp": "BE",
  "zurich": "CH", "geneva": "CH", "bern": "CH",
  "vienna": "AT", "salzburg": "AT",
  "warsaw": "PL", "krakow": "PL", "kraków": "PL",
  "prague": "CZ", "stockholm": "SE", "gothenburg": "SE",
  "oslo": "NO", "bergen": "NO",
  "copenhagen": "DK", "helsinki": "FI",
  "dublin": "IE", "athens": "GR", "thessaloniki": "GR",
  "bucharest": "RO", "budapest": "HU",
  "moscow": "RU", "st petersburg": "RU", "saint petersburg": "RU",
  "kyiv": "UA", "kiev": "UA",
};

export function countryToTimezone(countryNameOrCode) {
  if (!countryNameOrCode) return null;
  const code = COUNTRY_NAME_TO_CODE[countryNameOrCode] || countryNameOrCode.toUpperCase();
  return COUNTRY_TIMEZONE_MAP[code] || null;
}

// Resolves a lead's timezone using country FIRST, then falling back to city/city_area.
// Returns {tz, city, weekend, source: 'country' | 'city'} or null.
export function resolveLeadTimezone({ country, city, city_area } = {}) {
  if (country) {
    const r = countryToTimezone(country);
    if (r) return { ...r, source: "country" };
  }
  for (const c of [city, city_area]) {
    if (!c) continue;
    const code = CITY_TO_COUNTRY[c.trim().toLowerCase()];
    if (code && COUNTRY_TIMEZONE_MAP[code]) {
      return { ...COUNTRY_TIMEZONE_MAP[code], source: "city" };
    }
  }
  return null;
}

export function countryCodeFromName(name) {
  if (!name) return null;
  return COUNTRY_NAME_TO_CODE[name] || (name.length === 2 ? name.toUpperCase() : null);
}
